"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

function randString() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 11;
  var fragments = [];

  while (len > 0) {
    var fragment = Math.random().toString(36).slice(2);
    fragments.push(fragment.slice(0, len));
    len -= fragment.length;
  }

  return fragments.join('');
}

randString["default"] = randString;
var _default = randString;
exports["default"] = _default;
module.exports = exports["default"];